import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import React, { PropsWithChildren, useContext } from "react";
import useBotSummaryTabsValuesProvider from "@shared/features/bots/BotForm/useBotSummaryTabsValuesProvider";

const BotSummaryTabsValuesProvider = ({ children }: PropsWithChildren) => {
  const botFormContextValues = useContext(BotFormContext)!;

  const {
    tabToRestoreChangesData: signalsBotTabToRestoreChangesData,
    backtestingValuesModified,
    setBacktestingValuesModified,
    signalsMainCoinsData,
  } = useBotSummaryTabsValuesProvider();

  return (
    <BotFormContext.Provider
      value={{
        ...botFormContextValues,
        tabToRestoreChangesData: signalsBotTabToRestoreChangesData,
        backtestingValuesModified,
        setBacktestingValuesModified,
        signalsMainCoinsData,
      }}
    >
      {children}
    </BotFormContext.Provider>
  );
};

export default BotSummaryTabsValuesProvider;
